import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

const emptyToUndefined = (value: unknown) =>
  value === '' || value === undefined ? undefined : value

const optionalString = z.preprocess(emptyToUndefined, z.string().optional())
const optionalUrl = z.preprocess(emptyToUndefined, z.string().url().optional())

const requiredUrl = (defaultUrl: string) =>
  z.preprocess(
    emptyToUndefined,
    import.meta.env.DEV
      ? z.string().url().default(defaultUrl)
      : z.string().url()
  )

export const clientEnv = createEnv({
  clientPrefix: 'NEXT_PUBLIC_',
  client: {
    NEXT_PUBLIC_PGEE_API_BASE_URL: requiredUrl('http://api.lvh.me:3200'),
    NEXT_PUBLIC_SENTRY_DSN: optionalUrl,
    NEXT_PUBLIC_PGEE_APP_ENV: optionalString,
    NEXT_PUBLIC_PGEE_APP_VERSION: optionalString,
    NEXT_PUBLIC_PGEE_APP_DATA_VERSION: optionalString.default('1'),
    NEXT_PUBLIC_PGEE_COOKIE_DOMAIN: optionalString,
    NEXT_PUBLIC_PGEE_GOOGLE_MAPS_API_KEY: optionalString,
    NEXT_PUBLIC_PGEE_RECAPTCHA_SITE_KEY: optionalString
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
  skipValidation: !!import.meta.env.SKIP_ENV_VALIDATION
})
